<template>
  <div style="height: 100%;">
    <MarkdownViewer :markdownContent="markdownContent" />
  </div>
</template>

<script>
import MarkdownViewer from '@/components/MarkdownViewer.vue'
import api from '@/api';

export default {
  components: {
    MarkdownViewer,
  },
  data() {
    return {
      markdownContent: '',
    }
  },
  mounted() {
    // 假设您有一个 markdown 文件，可以使用 axios 获取内容
    api.get('/download/resource/about.md').then(response => {
      this.markdownContent = response
    })
  },
}
</script>